export type ClassificationItem = {
  title: string;
  image: string;
  testID?: string;
};

export type ClassificationPanelItemProps = {
  items: readonly ClassificationItem[];
};

export function ClassificationPanelItem({ items }: ClassificationPanelItemProps) {
  if (items.length === 0) {
    return null;
  }

  const columns = items.length === 1 ? '1fr' : '1fr 1fr';

  return (
    <div className="bg-white gap-1 mt-1" style={{ display: 'grid', gridTemplateColumns: columns }}>
      {items.map((item) => (
        <div
          key={item.title}
          className="d-flex flex-row gap-2 p-2 bg-dark bg-opacity-10 rounded-2 align-items-center justify-content-start"
          data-testid={item.testID}
        >
          <img src={item.image} alt={item.title} style={{ width: '32px', height: '32px' }} />
          <span className="small" style={{ lineHeight: '1rem' }}>
            {item.title}
          </span>
        </div>
      ))}
    </div>
  );
}
